import { render, staticRenderFns } from "./SwiperComponent.vue?vue&type=template&id=c6c18c32&scoped=true"
import script from "./SwiperComponent.vue?vue&type=script&lang=js"
export * from "./SwiperComponent.vue?vue&type=script&lang=js"
import style0 from "./SwiperComponent.vue?vue&type=style&index=0&id=c6c18c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c18c32",
  null
  
)

export default component.exports